import React from 'react';
import PropTypes from 'prop-types';
import FormControl from './FormControl';
import { EditorState, convertToRaw, convertFromRaw } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import { S3MediaUploader } from '../../Uploader/S3Uploader';
import EverfiImageControl from './RichTextCustomComponent/EverfiImage';
import getImageComponent from './RichTextCustomComponent/EverfiImage/renderer';

export default class RichText extends FormControl {
  static propTypes = {
    onChange: PropTypes.func,
    onValueChange: PropTypes.func,
    dataValue: PropTypes.any,
    multilingual: PropTypes.bool,
    activeLanguage: PropTypes.string,
    caption: PropTypes.string,
    languages: PropTypes.arrayOf(PropTypes.object),
    toolbarIconOptions: PropTypes.object
  };

  static defaultProps = {
    multilingual: false,
    toolbarIconOptions: {
      options: ['inline', 'blockType', 'list', 'textAlign', 'colorPicker', 'link', 'history']
    }
  };

  constructor(props) {
    super(props);
    this.loadEditorState(props.dataValue);
  }

  componentWillReceiveProps(newProps){
    if(this.props.activeLanguage !== newProps.activeLanguage && newProps.dataValue !== this.state.draftSource){
      this.loadEditorState(newProps.dataValue);
    }
  }

  uploadImageCallBack = async (file) => {
    let response = await S3MediaUploader(file);
    // react-wysiwyg requires the image to be available in 'link' in the response from uploaded file
    return new Promise(
      (resolve, reject) => {
        resolve({ data: { link: response && response.data && response.data.attributes ? response.data.attributes.url : null } });
      }
    );
  }

  loadEditorState = (dataValue) => {
    let editorState = EditorState.createEmpty();
    if(dataValue){
      const contentState = convertFromRaw(JSON.parse(dataValue));
      if(contentState){
        editorState = EditorState.createWithContent(contentState);
      }
    }
    this.state = {
      editorState,
      draftSource: JSON.stringify(convertToRaw(editorState.getCurrentContent()))
    };
  }

  onEditorStateChange = (editorState) => {
    const draftSource = JSON.stringify(convertToRaw(editorState.getCurrentContent()));
    this.setState({
      editorState,
      draftSource
    });
    this.onChange(draftSource, false);
  };

  onChange = (value, skipValueChange) => {
    if (typeof this.props.onChange === 'function'){
      this.props.onChange(value);
    }
    if (typeof this.props.onValueChange === 'function' && !skipValueChange){
      this.props.onValueChange({ [this.props.name]: value });
    }
  }

  customBlockRenderFunc = (block, config, getEditorState) => {
    if(block.getType() === "atomic"){
      return {
        component: getImageComponent(config),
        editable: false
      };
    } else{
      return undefined;
    }
  }

  render() {
    let { caption, name, multilingual, activeLanguage, languages, toolbarIconOptions } = this.props;
    const { editorState } = this.state;
    let currentLanguageObj = languages ? languages.find(language => { return Object.keys(language)[0] === activeLanguage}) : undefined;
    if(toolbarIconOptions.image){
      toolbarIconOptions.image.uploadCallback = this.uploadImageCallBack;
    }
    return (
      <div>
        <span className="caption pull-left">{caption}</span>
        { multilingual && currentLanguageObj && <span className="col-form-label pull-left">&nbsp;{`(${currentLanguageObj[activeLanguage]})`}</span> }
        <span className="clearfix"/>
        <Editor
          editorState={editorState}
          onEditorStateChange={this.onEditorStateChange}
          wrapperClassName="richtext-wrapper"
          editorClassName="richtext-editor"
          toolbar={toolbarIconOptions}
          toolbarCustomButtons={[<EverfiImageControl config={{ uploadCallback: this.uploadImageCallBack,
            alt: { present: true, mandatory: true }, previewImage: true
          }}
          />]}
          customBlockRenderFunc={this.customBlockRenderFunc}
        />
        <input type="hidden" id="richtext_editor" value={this.state.draftSource} name={name} />
      </div>
    );
  }
}
